import { ApplicationState, AppThunkDispatch } from "../../store";
import { connect } from "react-redux";
import UserForm  from "../../components/Forms/UserForm";
import { UserEntity } from "../../store/entities/state";
import { getChangingState, getChangingValue, isSubmittingNew } from "../../store/entities/selectors";
import { createEntity, entityCreatingCancel, updateChangingEntity } from "../../store/entities/actions";
import { createUserAsync } from "../../ajax/requests";
import { UserFormData, UserFormDispatchProps, UserFormStateProps } from "../../components/Forms/UserForm/UserForm";
import { CreateUserData } from "../../models";

const mapStateToProps = (state: ApplicationState): UserFormStateProps => ({
    type: 'create',
    canEdit: true,
    data: getChangingValue(state, 'users') as UserFormData,
    hasChanged: getChangingState(state, 'users'),
    isSubmitting: isSubmittingNew(state, 'users'),
})

const mapDispatchToProps = (dispatch: AppThunkDispatch): UserFormDispatchProps => ({
    onChange: (data: UserFormData) => dispatch(updateChangingEntity('users', data)),
    onCancel: () => dispatch(entityCreatingCancel('users')),
    onSave: (data: UserEntity) => dispatch(createEntity('users', data, c => createUserAsync(c as unknown as CreateUserData))),
});

export default connect<UserFormStateProps, UserFormDispatchProps, unknown, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(UserForm as any);